import { Plugin } from "prosemirror-state";
import { EditorView } from "prosemirror-view";

import { Extension } from "../extension";
import { isVisuallyEmpty } from "../utils";

export class GlobalPlaceholder extends Extension {
	get name() {
		return "global-placeholder";
	}

	get defaultOptions() {
		return {
			text: "",
		};
	}

	get plugins() {
		function updateView(view: EditorView) {
			const doc = view.state.doc;
			const empty =
				doc.childCount == 0 ||
				(doc.childCount == 1 &&
					doc.firstChild &&
					doc.firstChild.isTextblock &&
					doc.firstChild.content.size == 0 &&
					isVisuallyEmpty(doc.firstChild)) ||
				false;

			view.dom.classList.toggle("ProseMirror-empty", empty);
		}

		return [
			new Plugin({
				view: (view: EditorView) => {
					(view.dom as HTMLElement).dataset.placeholder = this.options.text;

					updateView(view);

					return {
						update: (view: EditorView) => {
							updateView(view);
						},
						destroy: () => {
							delete (view.dom as HTMLElement).dataset.placeholder;
						},
					};
				},
			}),
		];
	}
}

export default GlobalPlaceholder;
